import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

const seriesBadgeStyle = css`
  background-color: #3fcde3;
  color: #000000;
  display: flex;
  /* font-size: 21px; */
  align-items: center;
  justify-content: center;
  width: fit-content;
  /* padding: 5px 7px 5px 7px; */
  padding: 4px 12px;
  border-radius: 3.6px;
  text-transform: uppercase;
  font-weight: 600;
`
const SeriesBadge = () => {
  const [t] = useTranslation()
  return (
    <div css={seriesBadgeStyle}>
      <div>{t('card.tag.series', 'Series')}</div>
    </div>
  )
}

export default SeriesBadge
